import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TestForwardandBackward from './TestForwardandBackward';
import AccidentalWindowClose from '../../components/AccidentalWindowClose/AccidentalWindowClose';
import PageDetect from '../../components/ApplicantModal/PageDetect';
import CountDownTestTimer from './CountDownTestTimer';
import { useLocation } from 'react-router-dom';
import TestScore from './TestScore';
import { BsFillJournalBookmarkFill } from 'react-icons/bs';
import { useAppDispatch, useAppSelector } from '../../useStore';
import { reset, sendTest } from '../../features/Test/testSlice';
import swal from "sweetalert";

const TestQuestion = () => {
	const location = useLocation()
	const dispatch = useAppDispatch();
	const data = location?.state?.data;
	// @ts-ignore  
	const success = JSON.parse(localStorage.getItem(data?.id?.toString())) ?? false;
	const { sendTestisError, sendTestisLoading, sendTestmessage, sendTestisSuccess } = useAppSelector((state: { test: any; }) => state.test)



	useEffect(() => {
		if (sendTestisError) {
			swal({
				title: "error",
				text: sendTestmessage,
				icon: "error"
			})
			dispatch(reset())
		} else if (sendTestisSuccess) {
			swal({
				title: "success",
				text: "Your test has been submitted successfully!",
				icon: "success"
			})
			localStorage.setItem(data?.id.toString(), JSON.stringify(true));
			dispatch(reset())

		}
	}, [data?.id, dispatch, sendTestisError, sendTestisSuccess, sendTestmessage])

	const [showerr, setShowerr] = useState<any>(false);

	const [active, setActive] = useState(1)
	const testQuestions = data?.TestQuestions?.map((item: any, index: any) => ({
		question: item.question,
		a: item.optionA,
		b: item.optionB,
		c: item.optionC,
		d: item.optionD,
		score: item.score,
		id: index + 1,
		ans: "",
		correctAns: item.correctAnswer === "optionA" ? "a" :
			item.correctAnswer === "optionB" ? "b" :
				item.correctAnswer === "optionC" ? "c" : "d",

	}));
	const [testscore, setTestscore] = useState<any>(testQuestions)
	const [displayData, setDisplayData] = useState([]);
	const [testTotleScore, setTestTotleScore] = useState(0);
	const [over, setOver] = useState(false);

	useEffect(() => {
		if (testscore) {
			const result = testscore?.filter((data: { id: any; }) => data.id === active);
			setDisplayData(result);
		}
	}, [active, testscore]);



	const calculateScore = () => {
		const scores = testscore.map((item: { score: any; }) => item.score)
		const totalScore = scores.reduce((x: any, y: any) => x + y, 0)
		setTestTotleScore(totalScore);
		return totalScore;
	}



	const handleChange = (input: any, value: any, item: any,) => {
		let items = [...testscore];
		let oldItem = items.findIndex((x) => x.id === item.id);
		let newItem = { ...items[oldItem], [input]: value, score: item.correctAns === value ? 5 : 0 };
		items[oldItem] = newItem;
		setTestscore(items);
	};


	const incrementCountCancel = () => {
		// Update state back to one      
		setActive(1);
	};


	const info: any = { data, testTotleScore }

	// const info = useMemo(() => [data, testTotleScore], [data, testTotleScore]);



	useEffect(() => {
		if (over) {
			// @ts-ignore 
			dispatch(sendTest(info));
			setTimeout(() => {
				setOver(false);
			}, 1000);
		}
	}, [dispatch, info, over, setOver]);


	const handleSendTest = () => {
		// @ts-ignore  
		dispatch(sendTest(info));
	}


	return (
		<div>
			<header className="ChatProgressView-header"  >
				{success ? "" :
					<div className='Update-titile-icon'>
						<BsFillJournalBookmarkFill color='#0b03fc' />
						<div className="in-progresss">
							Do not leave this page
						</div>
					</div>
				}
			</header>

			<div id="body-questions">
				{success ? "" : <CountDownTestTimer data={data} setOver={setOver} over={over} />}
				{active === testscore?.length + 1 || success ?
					<TestScore
						id={data?.id}
						calculateScore={calculateScore}
						incrementCountCancel={incrementCountCancel}
						handleSendTest={handleSendTest}
						sendTestisLoading={sendTestisLoading} />
					: displayData?.map((item: any) => (
						<div className="quize" key={item.id}>
							<div className="question-bar">
								<h2 className="qestion">{item.id}) {item.question}</h2>

								<ul>
									<li>
										<input type="radio" name="option" id="a" className="ansList"
											value={item.ans.includes('a')}
											onChange={(e) => handleChange("ans", 'a', item)} />
										<label htmlFor="a" className="ansa">{item.a}</label>
									</li>
									<li>
										<input type="radio" name="option" id="b" className="ansList"
											value={item.ans.includes('b')}
											onChange={(e) => handleChange("ans", 'b', item)} />
										<label htmlFor="b" className="ansb">{item.b}</label>
									</li>
									<li>
										<input type="radio" name="option" id="c" className="ansList"
											value={item.ans.includes('c')}
											onChange={(e) => handleChange("ans", 'c', item)} />
										<label htmlFor="c" className="ansc">{item.c}</label>
									</li>
									<li>
										<input type="radio" name="option" id="d" className="ansList"
											value={item.ans.includes('d')}
											onChange={(e) => handleChange("ans", 'd', item)} />
										<label htmlFor="d" className="ansd">{item.d}</label>
									</li>
								</ul>
								<div className="footer-button">
									<TestForwardandBackward setActive={setActive} active={active} calculateScore={calculateScore} />
								</div>
							</div>
							<div id="showscore" className="scoreArea" style={{ color: "#0b03fc", fontWeight: "bold", fontSize: "20px" }}>{item.id} of {testscore.length}</div>
						</div>

					))}
			</div>

			<PageDetect setShowerr={setShowerr} showerr={showerr} />
			<AccidentalWindowClose setShowerr={setShowerr} />
		</div>
	)
}

export default React.memo(TestQuestion) 
